/** @jsx jsx */
import { Flex } from "@eworkit/iris";
import { FC, useCallback } from "react";
import { jsx } from "theme-ui";

import { useJobApplicationQuery } from "@/data/job-applications/queries/useJobApplicationQuery";
import { withRouteProps } from "@/infrastructure/Route";
import { JobApplicationDetailsHeader } from "@/views/job-applications/details/_components/JobApplicationDetailsHeader";
import { JobApplicationDetailsTabPanels } from "@/views/job-applications/details/_components/JobApplicationDetailsTabPanels";
import { JobApplicationDetailsRouteProps, transformRouteProps } from "@/views/job-applications/details/selectors";

interface JobApplicationDetailsViewComponentProps extends JobApplicationDetailsRouteProps {}

export const JobApplicationDetailsViewComponent: FC<JobApplicationDetailsViewComponentProps> = ({ routeProps }) => {
  const { data, refetch } = useJobApplicationQuery(routeProps.jobApplicationId);

  const handleSaved = useCallback(() => {
    refetch?.();
  }, [refetch]);

  return (
    <Flex flexDirection="column">
      <JobApplicationDetailsHeader jobApplication={data} onSaved={handleSaved} />
      <JobApplicationDetailsTabPanels jobApplication={data} />
    </Flex>
  );
};

export const JobApplicationDetailsView = withRouteProps(JobApplicationDetailsViewComponent, transformRouteProps);
